const newsRadarRoute = [
  {
    path: "/newsradar/configuration",
    name: "newsradar-config",
    component: () => import("@/views/news-radar/Config"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
      //   rmrAnalytics: {
      //     track: true,
      //     eventType: "veille-globale-config",
      //     eventCategory: "page-view",
      //   },
    },
  },
  {
    path: "/newsradar/db-overview",
    name: "newsradar-db",
    component: () => import("@/views/news-radar/DbOverview"),
    meta: {
      layout: "content",
      resource: ["news_radar", "leparisien_editorialink"],
      action: ["manage", "read"],
      rmrAnalytics: {
        track: true,
        eventType: "veille-globale-db",
        eventCategory: "page-view",
      },
    },
  },
  {
    // Ouverte a `news_radar/manage` (et non `all/manage` comme la
    // Configuration) : c'est tout l'objet de la page, demander une source
    // sans toucher aux configs. Le back applique les regles (worker 5 min).
    path: "/newsradar/source-request",
    name: "newsradar-source-request",
    component: () => import("@/views/news-radar/SourceRequest"),
    meta: {
      layout: "content",
      resource: "news_radar",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "veille-globale-source-request",
        eventCategory: "page-view",
      },
    },
  },
];

export default newsRadarRoute;
